import EventBus from "eventing-bus";
import { connect } from 'react-redux';
import React, { Component } from 'react';
// import withNavigation from './withNavigation'; 

import './index.css';
import { web3 } from '../../store/web3';
import Navbar from '../../components/navbar';
import Loader from '../../components/loader-bridge';
import { explorer, solanaExplorer, solanCluster } from '../../store/config';
import { setBurnNftRecord, createBurnNftRecord, mintNewNft, setMintedNft, getBurnNftHistory, getWalletNft, setWalletNft } from '../../store/actions/Auth';
import BurnAbi from '../../store/contract/development/BurnABI.json'



class Bridge extends Component {
    constructor(props) {
        super(props);
        this.state = {
            solanaWallet: '',
            transactionHash: '',
            burnNftRecord: { tokenId: null, contractAddress: null },
            isLoading: false

        };
    };

    async componentDidMount() {
        const { publicAddress } = this.props;
        if (publicAddress) {
            this.loadUserData(publicAddress);
        }
    };

    async componentWillReceiveProps({ publicAddress, isBurnNftRecord, nftMinted }) {
        const { tokenId, contractAddress } = this.state.burnNftRecord;

        if (isBurnNftRecord === true && contractAddress && tokenId) {
            const txhash = await this.handleContractBurn(publicAddress, contractAddress, tokenId);
            if (txhash) {
                let data = { tokenId, transactionHashEtherum: txhash, status: 'burned' }
                this.props.setBurnNftRecord(false);
                await this.props.mintNewNft(data);
            }
        }
        if (isBurnNftRecord === false, nftMinted !== null) {
            await this.loadUserData(publicAddress);
            this.props.setMintedNft(null)
            this.setState({ isLoading: false });
        }
    }


    componentDidUpdate(prevProps) {
        const { publicAddress } = this.props;
        if (publicAddress && publicAddress !== prevProps.publicAddress) {
            this.loadUserData(publicAddress);
        }
    }

    loadUserData = async (publicAddress) => {
        try {
            setTimeout(() => {
                this.props.getBurnNftHistory(publicAddress);
            }, 0);
            await this.props.getWalletNft(publicAddress);
        } catch (e) {
            console.error('Error loading user data:', e);
        }

    };

    handleContractBurn = async (walletAddress, contractAddress, tokenId) => {
        this.setState({ isLoading: true });
        try {
            const nftContract = new web3.eth.Contract(BurnAbi, contractAddress);
            const zeroAddress = '0x000000000000000000000000000000000000dEaD';
            const baseGasPrice = await web3.eth.getGasPrice();
            const gasPrice = Math.floor(Number(baseGasPrice) * 2);
            const tx = await await nftContract.methods.safeTransferFrom(walletAddress, zeroAddress, tokenId)
                .send({ from: walletAddress, gas: 300000, gasPrice: gasPrice })


            return tx.transactionHash
        } catch (error) {
            console.log(error)
            this.setState({ isLoading: false });
        }
    }

    handleBurnNft = async (tokenId, contractAddress, name, symbol, image) => {
        const { publicAddress } = this.props;
        const solanaWallet = this.state.solanaWallet || '';

        this.setState({ burnNftRecord: { tokenId, contractAddress } });
        this.setState({ isLoading: true });
        if (!publicAddress) {
            EventBus.publish('info', "Please connect your wallet first.");
            this.setState({ isLoading: false });
            return;
        }

        if (!solanaWallet) {
            EventBus.publish('info', 'Please add Solana wallet address.');
            this.setState({ isLoading: false });
            return;
        }

        try {
            // Step 1: Create burn record
            let data = {
                nftName: name,
                nftSymbol: symbol,
                image,
                nftContractAddress: contractAddress,
                nftTokenId: tokenId,
                EtherumWallet: publicAddress,
                SolanaWallet: solanaWallet,
                status: 'pending',
                completedAt: null
            }
            this.setState({ isLoading: true });
            await this.props.createBurnNftRecord(data);
            this.setState({ isLoading: false });
        } catch (error) {
            console.error("Error during burn process:", error);
            EventBus.publish('error', 'Failed to burn NFT. Please try again.');
            this.setState({ isLoading: false });
        }
    };


    render() {
        let { sticky, publicAddress, burnHistory, nftMetadata } = this.props;
        return (
            <div className="mp-club-page" onWheel={this.onScroll}>
                {this.state.isLoading && (<Loader />)}
                <Navbar sticky={sticky} />
                <div className="bridge-modals">
                    <div className="auto-container">
                        <div className="row">
                            <div className="col-12">
                                <div className='content-area bridge-content-area'>
                                    <div className="top-area">
                                        <div className="logo-area">
                                            <img src={require('../../static/images/new-landing/logo-banner.png')} alt='' />
                                        </div>
                                        <div className="sec-title text-center">
                                            <h2><img src={require('../../static/images/new-landing/bridge-title.png')} alt='' /></h2>
                                        </div>
                                    </div>
                                    <div className="bridge-section">

                                        <div className="wallet-to-sec">
                                            <div className="wallet-left">
                                                <div className="wallet-inner">
                                                    <div className="wallet-logo">
                                                        <i><img src={require('../../static/images/new-landing/eth-icon.png')} alt='' /></i>
                                                        ethereum
                                                    </div>
                                                    <button className="wallet-connect-btn">{publicAddress && publicAddress.substring(0, 10) + '.....' + publicAddress.substring(32, publicAddress.length)}</button>
                                                </div>
                                            </div>
                                            <div className="to-btn">
                                                <img src={require('../../static/images/new-landing/to-btn.png')} alt='' />
                                            </div>
                                            <div className="wallet-left">
                                                <div className="wallet-inner">
                                                    <div className="wallet-logo">
                                                        <i><img src={require('../../static/images/new-landing/solana-icon.png')} alt='' /></i>
                                                        solana
                                                    </div>
                                                    <input type="text" onChange={(e) => this.setState({ solanaWallet: e.target.value })} placeholder="Entry your wallet adress" value={this.solanaWallet} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="nft-selection-area">
                                            <div className="nft-inner-area">
                                                {nftMetadata.length === 0 ? (
                                                    <p>No NFT found in your wallet</p>
                                                ) : (
                                                    nftMetadata.map((nft, index) => (
                                                        <div className="nft-box" key={index}>
                                                            <img src={nft.imageUrl} alt='' />
                                                            {/* <p>{nft.imageUrl}</p> */}
                                                            <div className="burn-area">
                                                                <span className="number-id">#{nft.name.match(/\d+/g)?.pop()}</span>
                                                                <button onClick={() => this.handleBurnNft(nft.tokenId, nft.contract, nft.name, nft.symbol, nft.imageUrl)} className="burn-btn" type="button">
                                                                    <span>burn</span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    ))
                                                )}
                                            </div>

                                        </div>
                                    </div>
                                    <div className="history-sec">
                                        <h2>History</h2>
                                        <div className="bottom-data-area">
                                            <div className="table-responsive">
                                                <table className="table">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">NFT</th>
                                                            <th scope="col">ID</th>
                                                            <th scope="col">Ethereum</th>
                                                            <th scope="col">Solana</th>
                                                            <th scope="col">Date</th>
                                                            <th scope="col">Status</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {burnHistory.length > 0 ? (
                                                            burnHistory.map((item, index) => (
                                                                <tr key={index}>
                                                                    <th scope="row">
                                                                        <div className="nft-box">
                                                                            <img src={item.image || require('../../static/images/nft-1.png')} alt='' />
                                                                            <span className="name">{item.nftName}</span>
                                                                        </div>
                                                                    </th>
                                                                    <td>
                                                                        {item.nftTokenId.substring(0) &&
                                                                            <div className="text-box">
                                                                                #{item.nftTokenId.substring(0, 3)}...{item.nftTokenId.substring(item.nftTokenId.length - 3)}
                                                                                <div className="overlabox">
                                                                                    #{item?.nftTokenId}
                                                                                </div>

                                                                            </div>
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {item?.transactionHashEtherum?.substring(0)
                                                                            ? <a href={`${explorer}/tx/${item?.transactionHashEtherum}`} target="_blank">
                                                                                <div className="text-box">
                                                                                    <i>
                                                                                        <img src={require('../../static/images/new-landing/eth-icon.png')} alt='' />
                                                                                    </i>
                                                                                    {item?.transactionHashEtherum?.substring(0, 3)}...{item?.transactionHashEtherum?.substring(item?.transactionHashEtherum?.length - 3)}

                                                                                    <>
                                                                                        <div className="overlabox">
                                                                                            <a href={`${explorer}/tx/${item?.transactionHashEtherum}`}>
                                                                                                {item?.transactionHashEtherum}
                                                                                            </a>
                                                                                        </div>
                                                                                        <i className="icon-arow">
                                                                                            <svg fill="#ffffff80" height="800px" width="800px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 330.002 330.002">
                                                                                                <path id="XMLID_103_" d="M233.252,155.997L120.752,6.001c-4.972-6.628-14.372-7.97-21-3c-6.628,4.971-7.971,14.373-3,21
                                                                                        l105.75,140.997L96.752,306.001c-4.971,6.627-3.627,16.03,3,21c2.698,2.024,5.856,3.001,8.988,3.001
                                                                                        c4.561,0,9.065-2.072,12.012-6.001l112.5-150.004C237.252,168.664,237.252,161.33,233.252,155.997z"/>
                                                                                            </svg>
                                                                                        </i>
                                                                                    </>
                                                                                </div>
                                                                            </a>
                                                                            : <div className="text-box">
                                                                                Wallet address empty
                                                                            </div>
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {item?.transactionHashSolana?.substring(0)
                                                                            ? <div className="text-box">
                                                                                <i>
                                                                                    <img src={require('../../static/images/new-landing/solana-icon.png')} alt='' />
                                                                                </i>
                                                                                {item?.transactionHashSolana?.substring(0, 3)}...{item?.transactionHashSolana?.substring(item?.transactionHashSolana?.length - 3)}
                                                                                {item?.transactionHashSolana?.substring(0) &&
                                                                                    <div className="overlabox">
                                                                                        <a href={`${solanaExplorer}/tx/${item?.transactionHashSolana}/?cluster=${solanCluster}`}>
                                                                                            {item?.transactionHashSolana}
                                                                                        </a>
                                                                                    </div>
                                                                                }

                                                                                <>
                                                                                    <div className="overlabox">
                                                                                        <a href={`${solanaExplorer}/tx/${item?.transactionHashSolana}/?cluster=${solanCluster}`}>
                                                                                            {item?.transactionHashSolana}
                                                                                        </a>
                                                                                    </div>
                                                                                    <i className="icon-arow">
                                                                                        <svg fill="#ffffff80" height="800px" width="800px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 330.002 330.002">
                                                                                            <path id="XMLID_103_" d="M233.252,155.997L120.752,6.001c-4.972-6.628-14.372-7.97-21-3c-6.628,4.971-7.971,14.373-3,21
                                                                                        l105.75,140.997L96.752,306.001c-4.971,6.627-3.627,16.03,3,21c2.698,2.024,5.856,3.001,8.988,3.001
                                                                                        c4.561,0,9.065-2.072,12.012-6.001l112.5-150.004C237.252,168.664,237.252,161.33,233.252,155.997z"/>
                                                                                        </svg>
                                                                                    </i>
                                                                                </>
                                                                            </div>
                                                                            : <div className="text-box">
                                                                                Wallet address empty
                                                                            </div>
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        <div className="text-box">
                                                                            {new Date(item.createdAt).toLocaleDateString()}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="text-box">
                                                                            {item.status}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="6" style={{ textAlign: 'center', padding: '20px', color: 'white' }}>
                                                                    No records found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

const mapDispatchToProps = {
    setBurnNftRecord, createBurnNftRecord, mintNewNft, setMintedNft, getBurnNftHistory, getWalletNft, setWalletNft
};

const mapStateToProps = ({ Auth }) => {
    let { address, isBurnNftRecord, nftMinted, burnHistory, nftMetadata } = Auth;
    return { isBurnNftRecord, publicAddress: address, nftMinted, burnHistory, nftMetadata };
};

export default connect(mapStateToProps, mapDispatchToProps)(Bridge);
